import Vue from 'vue'
import Vuex from 'vuex'
import VueCookie from 'vue-cookie'
import DealerProgramConfig from '../static/DealerProgramConfig.json'

// Register the vuex
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authenticatedUser: null,
    program: '',
    unsavedData: false,
    applicationId: '',
    availableLenders: [],
    dealerApplication: {},
    dealerApplicationReferrers: [], //all the programs referrers (and the "selected" state)
    owners: [],
    locations: [],
    achAccounts: [],
    incArticles: [],
    cfArticles: [],
    orgTypes: [],
    llcTypes: [],
    loading: false,
    programsFetched: false,
    dealerInfoComplete: false,
    dealerCheckboxComplete: false,
    incArticlesComplete: false,
    cfArticlesComplete: false,
    ownerComplete: false,
    locationsComplete: true,
    achComplete: false,
    applicationJustCreated: false,
    applicationJustInvalidated: false,
    selectedExclusiveLender: ''
  },
  getters: {
    hasAnyoneEsigned: state => {
      for (var o of state.owners) {
        if (o.status == 'ESIGNED') {
          return true
        }
      }
      return false
    },
    isDealerApplicationComplete: (state, getters) => checkEsign => {
      var result =
        state.dealerInfoComplete &&
        state.incArticlesComplete &&
        (!getters.areFinancialsRequired || state.cfArticlesComplete) &&
        state.locationsComplete &&
        (!getters.isACHRequired || state.achComplete)


      if (checkEsign) {
        result = result && (state.ownerComplete)
      }

      // console.log('******** isDealerApplicationComplete *************')
      // console.log('dealerInfoComplete:'+state.dealerInfoComplete)
      // console.log('incArticlesComplete:'+state.incArticlesComplete)
      // console.log('cfArticlesComplete:'+state.cfArticlesComplete)
      // console.log('locationsComplete:'+state.locationsComplete)
      // console.log('achComplete:'+state.achComplete)
      // console.log('final answer:'+result)

      return result
    },
    isApplicationJustInvalidated: state => {
      return state.applicationJustInvalidated
    },
    isApplicationJustCreated: state => {
      return state.applicationJustCreated
    },
    isDealerInfoComplete: state => {
      return state.dealerInfoComplete
    },
    isDealerCheckboxComplete: state => {
      return state.dealerCheckboxComplete
    },
    isCfArticlesComplete: state => {
      return state.cfArticlesComplete
    },
    isIncArticlesComplete: state => {
      return state.incArticlesComplete
    },
    isOwnerComplete: state => {
      return state.ownerComplete
    },
    isLocationsComplete: state => {
      return state.locationsComplete
    },
    isAchComplete: state => {
      return state.achComplete
    },
    getAuthenticatedUser: state => {
      return state.authenticatedUser
    },
    getProgram: state => {
      return state.program
    },
    getDomain: state => {
      return state.program.domain
    },
    getProgramReferrers: state => {
      return state.program.referrers || []
    },
    isTDComplete: state => {
      return DealerProgramConfig[state.program.domain]['isTDComplete'];
    },
    isAvb: state => {
      return state.program.domain === 'avb-complete'
    },
    isAcceptanceNowSelected: state => {
      return (
        state.dealerApplication.lenders &&
        !!state.dealerApplication.lenders.find(lender => {
          return lender.bankId === 'anow'
        })
      )
    },
    isGenesisSelected: state => {
      return (
        state.dealerApplication.lenders &&
        !!state.dealerApplication.lenders.find(lender => {
          return lender.bankId === 'genesis'
        })
      )
    },
    isGafcoSelected: state => {
      return (
        state.dealerApplication.lenders &&
        !!state.dealerApplication.lenders.find(lender => {
          return lender.bankId === 'gafco'
        })
      )
    },
    getUnsavedData: state => {
      return state.unsavedData
    },
    getApplicationId: state => {
      return state.applicationId
    },
    getSelectedExclusiveLender: state => {
      return state.selectedExclusiveLender
    },
    getAvailableLenders: state => {
      return state.availableLenders
    },
    getDealerApplication: state => {
      return state.dealerApplication
    },
    getDealerApplicationReferrers: state => {
      return state.dealerApplicationReferrers
    },
    getOwners: state => {
      return state.owners
    },
    getFirstBeneficialOwner: (state, getters) => {
      if (state.owners) {
        for (var i = 0; i < state.owners.length; i++) {
          if (state.owners[i].status != 'UNINVITED') {
            return state.owners[i]
          }
        }
      }
    },
    getFirstBeneficialOwnerStatus: (state, getters) => {
      const owner = getters.getFirstBeneficialOwner
      if (owner) {
        return owner.status
      }
    },
    getLocations: state => {
      return state.locations
    },
    getAchAccounts: state => {
      return state.achAccounts
    },
    getIncArticles: state => {
      return state.incArticles
    },
    getCfArticles: state => {
      return state.cfArticles
    },
    getOrgTypes: state => {
      return state.orgTypes
    },
    getLLCTypes: state => {
      return state.llcTypes
    },
    getLoading: state => {
      return state.loading
    },
    programsFetched: state => {
      return state.programsFetched
    },
    getProgramConfig: state => item => {
      return DealerProgramConfig[state.program.domain][item] || DealerProgramConfig['default'][item]
    },
    isACHRequired: state => {
      return DealerProgramConfig[state.program.domain]['isACHRequired'];
    },
    isTCFRequired: state => {
      return DealerProgramConfig[state.program.domain]['isTCFRequired'];
    },
    hasEnrollmentKit: state => {
      return DealerProgramConfig[state.program.domain]['hasEnrollmentKit'];
    },
    isUsingDealerNumber: state => {
      return DealerProgramConfig[state.program.domain]['isUsingDealerNumber'];
    },
    getEnrollmentKitPath: state => {
      return (
        'static/' +
        state.program.domain +
        '/' +
        (DealerProgramConfig[state.program.domain]['enrollmentKit'] ||
          'EnrollmentKit.pdf')
      )
    },
    getProgramDisplayName: state => {
      return (DealerProgramConfig[state.program.domain]['displayName'] || state.program.name)
    }
  },
  mutations: {
    setApplicationJustInvalidated(state, invalidated) {
      state.applicationJustInvalidated = invalidated
    },
    setApplicationJustCreated(state, created) {
      state.applicationJustCreated = created
    },
    setDealerInfoComplete(state, complete) {
      state.dealerInfoComplete = complete
    },
    setDealerCheckboxComplete(state, complete) {
      state.dealerCheckboxComplete = complete
    },
    setIncArticlesComplete(state, complete) {
      state.incArticlesComplete = complete
    },
    setCfArticlesComplete(state, complete) {
      state.cfArticlesComplete = complete
    },
    setOwnerComplete(state, complete) {
      state.ownerComplete = complete
    },
    setLocationsComplete(state, complete) {
      state.locationsComplete = complete
    },
    setAchComplete(state, complete) {
      state.achComplete = complete
    },
    setAuthenticatedUser(state, authenticatedUser) {
      state.authenticatedUser = authenticatedUser
    },
    setProgram(state, program) {
      state.program = program
      var programString = program.id + '|' + program.name + '|' + program.domain
      VueCookie.set('program', programString, 1)
    },
    setUnsavedData(state, unsavedData) {
      state.unsavedData = unsavedData
    },
    setSelectedExclusiveLender(state, exclusive) {
      state.selectedExclusiveLender = exclusive
    },
    setApplicationId(state, applicationId) {
      state.applicationId = applicationId

      state.availableLenders = []
      state.dealerApplicationReferrers = []
      state.owners = []
      state.achAccounts = []
      state.incArticles = []
      state.cfArticles = []
      state.locations = []

      VueCookie.set('applicationId', applicationId)
    },
    setDealerApplicationReferrers(state, dealerApplicationRefs) {
      state.dealerApplicationReferrers = dealerApplicationRefs
    },
    setDealerApplication(state, dealerApplication) {
      dealerApplication.website = dealerApplication.website === 'true'
      dealerApplication.activeTdrcsDealer = dealerApplication.activeTdrcsDealer === 'true'
      dealerApplication.avbHostedWebsite = dealerApplication.avbHostedWebsite === 'true'
      dealerApplication.offerApplyAndBuy = dealerApplication.offerApplyAndBuy === 'true'
      dealerApplication.wantOnlineCreditAppLink = dealerApplication.wantOnlineCreditAppLink === 'true'
      state.dealerApplication = dealerApplication
    },
    setOwners(state, owners) {
      state.owners = owners
    },
    setLocations(state, locations) {
      state.locations = locations
    },
    setAchAccounts(state, achAccounts) {
      state.achAccounts = achAccounts
    },
    setIncArticles(state, incArticles) {
      state.incArticles = incArticles
    },
    setCfArticles(state, cfArticles) {
      state.cfArticles = cfArticles
    },
    setOrgTypes(state, orgTypes) {
      state.orgTypes = orgTypes
    },
    setLLCTypes(state, llcTypes) {
      state.llcTypes = llcTypes
    },
    resetApplication(state) {
      state.applicationId = ''
      state.dealerApplication = {}
      state.availableLenders = []
      state.dealerApplicationReferrers = []
      state.owners = []
      state.achAccounts = []
      state.incArticles = []
      state.cfArticles = []
      state.locations = []
      state.unsavedData = false
      VueCookie.delete('applicationId')
    },
    logout(state) {
      state.getAuthenticatedUser = ''
    },
    setAvailableLenders(state, availableLenders) {
      state.availableLenders = availableLenders
    },
    setLoading(state, xl) {
      state.loading = xl
    },
    setProgramsFetched(state, xl) {
      state.programsFetched = xl
    }
  },
  actions: {
    logout(context) {
      context.commit('resetApplication')
      context.commit('logout')
    },
    setDealerCheckboxComplete({ commit }) {
      commit('setDealerCheckboxComplete', true)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js